import { render } from "./SubjectInfo.vue?vue&type=template&id=5c423662&scoped=true"
import script from "./SubjectInfo.vue?vue&type=script&lang=js"
export * from "./SubjectInfo.vue?vue&type=script&lang=js"

import "./SubjectInfo.vue?vue&type=style&index=0&id=5c423662&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c423662"]])

export default __exports__